import React, { useEffect, useRef, useCallback } from 'react'
import styles from './styles.module.css'
import { ModalButtonContainer } from '../../ModalButtonContainer/ModalButtonContainer'
import { getCurrentLocation } from '../../../constans/functions/locationService';
import { groupImages, heroImages } from '../../../constans/countries/country_background';
import { countryGroups } from '../../../constans/countries/country_groups';


export const CountryModal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef();

  // Мемоизируем обработчики
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  // Закрытие по клику вне модалки
  const outsideClick = useCallback((event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleClose();
    }
  }, [handleClose]);

  // Закрытие по ESC
  const closeByEscKey = useCallback((event) => {
    if (event.key === 'Escape') {
      handleClose();
    }
  }, [handleClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', outsideClick);
      document.addEventListener('keydown', closeByEscKey);
    }
    
    return () => {
      document.removeEventListener('mousedown', outsideClick);
      document.removeEventListener('keydown', closeByEscKey);
    };
  }, [isOpen, outsideClick, closeByEscKey]);

  if (!isOpen) return null;

  getCurrentLocation();

  const findGroup = Object.entries(countryGroups).find(
    ([, e]) => e.includes(children.iso2)
  )?.[0];


  const coverImage =
        heroImages[children.iso2] ||
        groupImages[findGroup]


  return (
    <div className={styles.modal} onClick={handleClose}>    
      <div 
        className={styles.modal_wrapper} 
        ref={modalRef}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.modal_content}>
            <div className={styles.country_cover}
                style={{backgroundImage: `url('${coverImage}')`}}>
                <button 
                  className={styles.modal_close_button}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                  }}
                  aria-label='Close modal'
                >
                  ╳ 
                </button>
              <div className={styles.modalFlag}>{children.flag}</div>
            </div>
            <ModalButtonContainer children={children} />
          </div>
      </div>
    </div> 
  );
};